import { Link, useLocation } from "react-router-dom";
import { Phone, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

/**
 * StickyCTAV2 — bottom bar visible on mobile + desktop, hidden on /contact.
 */
export const StickyCTAV2 = () => {
  const location = useLocation();
  // Hidden on /contact (CTA redundant) and on the home (overlays multiple sections).
  if (location.pathname === "/contact" || location.pathname === "/") return null;

  return (
    <motion.div
      initial={{ y: 120, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1.4, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      data-testid="sticky-cta-v2"
      className="hidden lg:block fixed bottom-0 left-0 right-0 z-40 pointer-events-none"
    >
      <div className="pointer-events-auto mx-auto w-full max-w-[620px] px-3 md:px-5 pb-3 md:pb-5">
        <div className="flex items-stretch bg-fd-bg/85 backdrop-blur-2xl border border-fd-border rounded-full overflow-hidden shadow-[0_30px_80px_-20px_rgba(0,0,0,0.9),0_0_0_1px_rgba(212,162,76,0.08)]">
          <a
            href="tel:+33148680303"
            data-cursor-hover
            className="flex-1 flex items-center justify-center gap-2.5 text-fd-text/90 hover:text-fd-text hover:bg-white/5 px-5 py-3.5 transition-all duration-300 group"
          >
            <Phone size={14} className="text-fd-gold group-hover:scale-110 transition-transform" />
            <span className="font-mono text-[11px] tracking-[0.14em] uppercase">01 48 68 03 03</span>
          </a>
          <div className="w-px bg-fd-border"></div>
          <Link
            to="/contact"
            data-cursor-hover
            className="flex-1 flex items-center justify-center gap-2 bg-fd-gold hover:bg-fd-gold-bright text-black px-5 py-3.5 font-display uppercase tracking-[0.1em] text-[12px] transition-colors duration-300 group"
          >
            <span>Devis 24h</span>
            <ArrowUpRight size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </div>
      </div>
    </motion.div>
  );
};
